import * as React from 'react';

/* eslint-disable spellcheck/spell-checker */
var Linkedin = function (_a) {
    var _b = _a.idSuffix, idSuffix = _b === void 0 ? '' : _b;
    return (React.createElement("svg", { "aria-labelledby": "linkedin-icon-".concat(idSuffix), height: "40", role: "img", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "linkedin-icon-".concat(idSuffix) }, "Invitae's LinkedIn Page"),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "m15.03 29h-3.733v-12.018h3.732v12.018zm-1.87-13.657c-1.193 0-2.161-.988-2.161-2.182 0-1.193.968-2.161 2.161-2.161 1.194 0 2.161.968 2.161 2.161 0 1.194-.968 2.182-2.16 2.182zm15.836 13.657h-3.724v-5.85c0-1.394-.028-3.182-1.94-3.182-1.94 0-2.238 1.514-2.238 3.081v5.951h-3.727v-12.018h3.579v1.64h.052c.498-.945 1.715-1.941 3.53-1.941 3.778 0 4.472 2.487 4.472 5.718v6.601z", fill: "#161616", fillRule: "nonzero" }))));
};
/* eslint-enable spellcheck/spell-checker */

export { Linkedin as default };
//# sourceMappingURL=Linkedin.esm.js.map
